/*
 * @Descripttion: 
 * @version: 
 * @Author: yanghui
 * @Date: 2021-10-19 13:34:03
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-17 17:57:04
 */
/**
 * Created by lk on 17/6/4.
 */
 import axios from "../../utils/axios";

 // 获取列表
 export function msgList(data) {
     return axios({
         url: "/hfMsgManage/getMsgList",
         method: "post",
         data: data
     });
 }
 
 // 详情页
 export function msgDetails(query) {
     return axios({
         url: "/hfMsgManage/getMsgDetails",
         method: "get",
         params: query
     });
 }

 // 编辑页面
 export function msgEdit(data) {
  return axios({
      url: "/hfMsgManage/editMsg",
      method: "put",
      data: data
  });
}
 

// 删除消息
export function msgDelete(query) {
  return axios({
      url: "/hfMsgManage/delMsg",
      method: "put",
      params: query
  });
}

 
// 新删除
export function deleteNewApi(data) {
  return axios({
      url: "/hfMsgManage/delMsg",
      method: "post",
      data: data
  });
}
 
 